// Assembly: Overview
(function(window, document, undefined) {

  /*
   * Included File: overview.module.es6
   */
  // Plugin: transpileEs6
  function OverviewCtrl() {

    let guidedTour = document.querySelector('#guidedtour');

    function scrollToItem(item) {
      let expectedTop = window.scrollY; //IDX-7461 We calculate based on expected top to ensure the interval is canceled even if it can't scroll to the actual top.
      const interval = window.setInterval(() => {
        let diff = (item.offsetTop - expectedTop) / 8; //Calculate an eighth of the remaining distance; Recalculating diff each time creates an ease-in effect.
        if (Math.abs(diff) > 1) {
          expectedTop += diff;
        } else {
          expectedTop = item.offsetTop;
          window.clearInterval(interval);
        }
        window.scrollTo(0, expectedTop);
      }, 20);
    }

    this.scrollToGuidedTour = () => {
      scrollToItem(guidedTour);
    };
  }

  angular.module('Overview', ['SecondaryNav']).controller('OverviewCtrl', OverviewCtrl);

  OverviewCtrl.$inject = [];

})(window, document);
